import React, { forwardRef, useImperativeHandle } from "react";
import { Icons, Stack, Box, IconButton, MenuItem, SelectField } from "@curves/ui-base";
import { isEmpty, ensureArray } from "@util/utils";

/**
 * 抵用券設定組件
 * @param {Object} props - 組件屬性
 * @param {Array} [props.options=[]] - 抵用券選項列表
 * @param {number|null} [props.campaignID] - 當前選擇的抵用券ID
 * @param {Function} props.onChange - 抵用券選擇變更回調函數
 * @param {string} [props.className] - 自定義CSS類名
 * @param {Object} [props.otherProps] - 其他傳遞給根元素的屬性
 */
const CampaignSetting = forwardRef(({ className, options = [], campaignID, onChange, ...otherProps }, ref) => {
	const campaignOptions = ensureArray(options);
	const selectedCampaign = campaignOptions.find(item => item.value === campaignID);

	// 處理選擇變更
	const handleChange = (e, child) => {
		const value = e.target.value;
		if (onChange && typeof onChange === "function") {
			onChange(value || null);
		}
	};

	// 處理清除
	const handleClear = () => {
		if (onChange && typeof onChange === "function") {
			onChange(null);
		}
	};

	// 提供給父組件的方法
	useImperativeHandle(ref, () => ({
		getResult: () => campaignID || null,
	}));

	return (
		<Box className={className} {...otherProps}>
			{isEmpty(selectedCampaign) ? (
				<Stack direction="row" spacing={1} alignItems="center">
					<SelectField value={campaignID || ""} displayEmpty fullWidth onChange={handleChange}>
						<MenuItem disabled value="">
							<em>{campaignOptions.length === 0 ? "無抵用券可使用" : "請選擇"}</em>
						</MenuItem>
						{campaignOptions.map(({ value, text }) => (
							<MenuItem key={value} value={value}>
								{text}
							</MenuItem>
						))}
					</SelectField>
				</Stack>
			) : (
				<Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
					<Box className="pos-campaign-display">
						{selectedCampaign.text}
					</Box>
					<IconButton
						onClick={handleClear}
						style={{
							background: "none",
							border: "none",
							padding: "8px",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
						}}
					>
						<Icons.Close />
					</IconButton>
				</Stack>
			)}
		</Box>
	);
});

CampaignSetting.displayName = "CampaignSetting";

export default CampaignSetting;
